import { useState, useCallback, useEffect } from 'react';
import { getTaskListApi, deleteTaskApi } from '../Api/api.js';
// ================== 自定义 Hook：useHomeApi ==================
export const useHomeApi = () => {
   // 1.1 任务相关
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [tasks, setTasks] = useState([]);
  // 1.2 统计数据
  const [stats, setStats] = useState({
    totalClicks: 0,
    totalComments: 0,
    maxComments: 0
  });
 // 1.3 分页相关
 const [currentPage, setCurrentPage] = useState(1);
 const [pageSize, setPageSize] = useState(10);
  // ---------- 2. 数据获取 ----------
  // 2.1 获取任务列表
 const fetchTasks = useCallback(async () => {
  try {
    setLoading(true);
    const offset = (currentPage - 1) * pageSize;
    const data = await getTaskListApi(offset, pageSize);  
    // 适配后端返回的数据格式
    if (data && (data.success || (data.status === 200 && data.msg === 'success'))) {
      const tasks = data.data?.task_list || [];
      const total = data.data?.total || 0;
      setTasks(tasks);
      setTotal(total);
      return { success: true, data: data.data };
    } else {
      return { success: false, message: '获取任务列表失败' };
    }
  } catch (error) {
    
    return { success: false, error };
  } finally {
    setLoading(false);
  }
}, [currentPage, pageSize]); 
 // 2.2 获取统计数据（可根据实际需求替换为真实接口）
 const fetchStats = useCallback(async () => {
  try {
    // 这里可以调用真实的统计 API
    const mockStats = {
      totalClicks: 1250,
      totalComments: 850,
      maxComments: 1000
    };
    setStats(mockStats);
    return { success: true, data: mockStats };
  } catch (error) {
    
    return { success: false, error };
  }
}, []);
  // 2.3 获取评论列表（可根据实际需求替换为真实接口）
  const fetchComments = useCallback(async (taskId, page = 1, size = 10, filter = null) => {
    try {
      // 这里可以调用真实的评论 API
      const mockComments = {
        comments: [],
        total: 0
      };
      return { success: true, data: mockComments };
    } catch (error) {

      return { success: false, error };
    }
  }, []);
 // ---------- 3. 分页逻辑 ----------
  // 3.1 分页状态变化时自动获取数据
 useEffect(() => {
  if (currentPage > 0 && pageSize > 0) {
    fetchTasks();
  }
}, [currentPage, pageSize, fetchTasks]);
 // 3.2 分页切换处理
const handlePageChange = useCallback((page, size) => {
  // 使用函数式更新，避免闭包问题
  setCurrentPage(() => page);
  setPageSize(() => size);
}, []);
  // ---------- 4. 业务操作 ----------
  // 4.1 删除任务
  const deleteTask = useCallback(async (taskId) => {
    try {
      const data = await deleteTaskApi({ task_id: taskId });
      if ((data.success) || (data.status === 200 && data.msg === 'success')) {
        return { success: true };
      } else {
        return { success: false, message: '删除失败' };
      }
    } catch (error) {

      return { success: false, error };
    }
  }, []);

  // 4.2 更新任务状态（示例）
  const updateTaskStatus = useCallback(async (taskId, status) => {
    try {
      // 这里可以调用真实的更新状态 API
      return { success: true };
    } catch (error) {

      return { success: false, error };
    }
  }, []);
  return {
    // 状态
    loading,
    tasks,
    stats,
    total,  
    currentPage,
    pageSize,
    // 方法
    fetchTasks,
    fetchStats,
    deleteTask,
    updateTaskStatus,
    fetchComments,
    handlePageChange,
  };
};